import React from 'react';
import RicercaSanzioneService from "./ricercaSanzioneService";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { URL,EASY_KEY } from './worldline.config';
import { toast, ToastContainer } from 'react-toastify';
import anm from './logoANM.png';

class RicercaSanzioneR extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          loading: true,
          sanzioni: [],
          sanzione: "",
          cercaSanzione: "",
          sanzioneTrovata: false,
          captcha:"",
        };

        this.ricercaSanzioneService = new RicercaSanzioneService();
      }

      componentDidMount() {
        loadCaptchaEnginge(6);
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get("id");
        if(id!== null){
          this.setState({cercaSanzione: id});
        }
    
        // this.ricercaSanzioneService = new RicercaSanzioneService();
        // this.ricercaSanzioneService.getSanzioni(id, this.sanzione.bind(this));
      }

      onChangeCercaSanzione(event) {
        this.state.cercaSanzione = event.target.value;
        this.setState({ cercaSanzione: this.state.cercaSanzione });
      }

      onChangeCaptchaInput(event){
        this.state.captcha = event.target.value;
        this.setState({captcha:this.state.captcha});
      }

    //   sanzione(result) {
    //     this.setState({ sanzioni: result });
    //   }

      cercaSanzione() {
        if(validateCaptcha(this.state.captcha,true)){
            this.setState({ sanzione: "" });

            this.ricercaSanzioneService.searchSanzione(
              (result) => {
                this.setState({ sanzione: result.data });
                
                this.setState({cercaSanzione:""})

                document.getElementById("sanzioneTrovata").scrollIntoView()

              },
              this.state.cercaSanzione,
            );
            validateCaptcha("",true);
        }else{
          toast.error(`Captcha Errato`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }

        this.setState({captcha:""});

        if (this.state.sanzione === "") {
          this.setState({ sanzioneTrovata: true });
        } else {
          this.setState({ sanzioneTrovata: false });
        }
      }
       pagaSanzione(importoSanzione) {
        this.ricercaSanzioneService.pagaSanzione(this.state.sanzione.numeroSanzione,importoSanzione,(result) => {
          if (result.status === 200) {
            window.location.href = `${result.data.paymentID}`;
          }else{
            toast.error('Errore riprova piu tardi', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
        },(idSanzione)=>{
          toast.error(`Errore n. ${idSanzione} riprova piu tardi`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        });
       }

      // richiestaPagaSanzione() {

      // }

      render(){
        const dataRilascio = new Date(this.state.sanzione.dataEmissione);
            var data =
            dataRilascio.toLocaleDateString("it-IT")
        return(
            <div className='container-fluid ' style={{minHeight: "80vh"}}>
              <ToastContainer/>
              <div className='row d-flex flex-md-row flex-column-reverse justify-content-between justify-content-md-center align-items-center text-center text-lg-start pt-3 pl-lg-5'>
                    <h2 className='col-12 col-md-5'>RICERCA E PAGA UNA SANZIONE</h2>
                    <img className='col-5 col-md-5' src={anm} style={{height:"50px", width:"150px"}} alt='logo anm'/>
                </div>
                <div className='row d-flex flex-column flex-lg-row p-lg-5 p-lg-0 p-4 gap-4 gap-lg-0 align-items-center justify-content-center'>
                    <div className='col-10 mr-lg-5 col-lg-6 d-flex flex-column gap-5 align-items-center card h-100'>
                        <h3 className='pt-4'>Ricerca la tua sanzione</h3>
                        <div className='d-flex flex-column flex-lg-row gap-3'>
                            <label> N° Identificativo</label>
                            <input id="cercaSanzioneInput" type="text" value={this.state.cercaSanzione} onChange={this.onChangeCercaSanzione.bind(this)}
                            />
                        </div>
                        <div className='d-flex flex-column  gap-3 w-50 justify-content-center align-items-center'>
                            <LoadCanvasTemplate />
                            <input type="text" value={this.state.captcha} onChange={this.onChangeCaptchaInput.bind(this)}/>
                        </div>
                        <button
                            className="btn btn-primary mb-3"
                            onClick={this.cercaSanzione.bind(this)}
                            disabled={this.state.cercaSanzione.length < 5}>
                                CERCA
                                </button>
                    </div>
                    <div id='sanzioneTrovata' className='col-10 col-lg-4 d-flex flex-column justify-content-center ps-lg-5'>{this.state.sanzione === ""
                    ?<></>
                    :<div className='card d-flex flex-column py-3'>
                        <h5 className='card-title p-5 lh-lg'>N° Identificativo: <span className='fs-6'> {this.state.sanzione.numeroSanzione} </span></h5>
                        <div className='card-body'>
                            <h6 class="card-subtitle mb-2 text-muted p-3">Data Emissione: {data !=="1/1/1970"? data : ""}</h6>
                            {this.state.sanzione.importoDaPagareDue > 0 && <h6 className='text-danger'>In caso di pagamento di un importo inferiore o difforme a quanto dovuto, il versamento non avrà valore ai fini
dell&#39;estinzione dell&#39;obbligazione, comportando l’ingiunzione di pagamento per la sanzione intera oltre le spese.
L’eventuale importo non corretto versato potrà essere oggetto di richiesta di rimborso, che verrà autorizzato
dopo una verifica dell’avvenuto pagamento dell’’importo dovuto.</h6>}
                        </div>
                        <div className='d-flex justify-content-center p-0 m-2 justify-content-lg-center gap-2'>
                        {this.state.sanzione.importoDaPagareDue > 0
                        ?<button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagareDue)}
                            disabled={!this.state.sanzione.importoDaPagareDue > 0}
                        >
                            Paga Ora {(this.state.sanzione.importoDaPagareDue / 100).toFixed(2)} €
                        </button>
                        :""}
                        <button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagare)}
                            disabled={!this.state.sanzione.importoDaPagare > 0}
                        >
                            Paga Ora {(this.state.sanzione.importoDaPagare / 100).toFixed(2)} €
                        </button>
                        </div>
                    </div>}

                    </div>
                </div>
                <p className='text-center' style={{fontSize:"0.7rem"}}>A.N.M. S.p.A. Sede Legale: Via G. Marino n.1, 80125 Napoli-tel.: 081.763.1111 - fax: 081.763.2070</p>
                <p className='text-center' style={{fontSize:"0.7rem"}}> C.F. e numero d'iscrizione 06937950639 del Registro Imprese di Napoli - R.E.A. di Napoli n. 539416 - anmspa@pec.anm.it</p>
                <p className='text-center' style={{fontSize:"0.7rem"}}> Per richiesta supporto scrivere una mail al seguente indirizzo: sanzioniamministrative@anm.it</p>
            </div>
        )
      }

}

export default RicercaSanzioneR;